import { withGlobalBridge } from '@beefco/bridge';
import { createProjectBeefBus } from '@beefco/sdk-tools';
import { useAdminConnector } from "../../hooks";
/**
 * Pairs up with ProjectHooker in @beefco/platform-gui
 *   to provide communications
 */
var _PlatformHooker = function _PlatformHooker(_ref) {
  var pageId = _ref.pageId,
    pageSlug = _ref.pageSlug,
    libraryDSL = _ref.libraryDSL,
    libraryRootPath = _ref.libraryRootPath;
  useAdminConnector({
    pageId: pageId,
    pageSlug: pageSlug,
    libraryDSL: libraryDSL,
    libraryRootPath: libraryRootPath
  });
  return null;
};
export default withGlobalBridge(createProjectBeefBus)(_PlatformHooker);